export default __webpack_public_path__ + "static/12_exclusion-bde67e1eea5640efedaf7a62b37bb033.png";